import raphaelPic from "@/public/images/artists/raphael.png";
import { Artist } from "@/types/types";

export const raphael = {
  id: "40",
  name: "Raphael",
  image: raphaelPic,
  description: `Raphael is a dynamic male artist, whose voice resonates with a deep, powerful timbre that is a perfect match for rock, indie, and EDM. His vocals carry an emotional weight that's palpable, as if each note is a visceral expression of his soul. With a voice that can range from a soulful growl to a heart-wrenching croon, Raphael possesses the versatility to convey the full spectrum of human emotion.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fraphael-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Rock", "Country", "Soul", "Dance", "Blues", "Belting"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 50,
        high: 67,
      },
    },
  },
} as const satisfies Artist;
